import { Injectable } from '@angular/core';
import { StorageRepository, StorageResult } from '@okcargo-apps/shared-domain';

// TODO use this in backoffice

@Injectable()
export class WebStorageService implements StorageRepository {
  public async create(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  }

  public async read(key: string): Promise<StorageResult> {
    return { value: localStorage.getItem(key) };
  }

  public async update(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  }

  public async delete(key: string): Promise<void> {
    localStorage.removeItem(key);
  }

  public async clear(): Promise<void> {
    localStorage.clear();
  }
}
